
const OPEN_HIGHLIGHT_TAG = '<mark>'
const CLOSE_HIGHLIGHT_TAG = '</mark>'
const HIGHLIGHT_CLASS = 'tt-highlight'
const OPEN_HIGHLIGHT_TAG_WITH_CLASS = `<mark class="${HIGHLIGHT_CLASS}">`
const OPEN_CNTRL_CHAR = '\x02'
const CLOSE_CNTRL_CHAR = '\x03'

/**
 * Truncates the provided text given the truncateLength and truncateAllowance.
 * If the text does not need to be truncated, null string is returned.
 * Line breaks <br> and a space for opening and closing highlight tag (<mark>) are included in the
 * count. Count will be slightly off in these cases, but minimizes the code needed to handle.
 *
 * TODO: does this work for Chinese? Do we bother with Arabic?
 *
 * @param text - text to truncate (should already be trimmed, otherwise spaces count)
 * @param truncateLength - how long the truncated text should be
 * @param truncateAllowance - allows the text to go over a little without truncation. Helps avoid
 *                            a case where the expanded text is only a few more characters.
 */
export function truncateText(content, truncateLength, truncateAllowance = 0) {
  if (!content) {
    return null
  }
  let text = content
  // if it has highlight tags, change them to be control characters so they take up less
  // space for truncation
  if (text.indexOf(OPEN_HIGHLIGHT_TAG) > -1) {
    text = text.replace(new RegExp(OPEN_HIGHLIGHT_TAG, 'g'), '\x02')
               .replace(new RegExp(CLOSE_HIGHLIGHT_TAG, 'g'), '\x03')
  }
  const shouldTruncate = text && text.length > (truncateLength + truncateAllowance)
  if (!shouldTruncate) {
    return null
  }
  // replacing <br /> with <br> so it doesn't truncate in the middle of the tag.
  // br should only count for one character, but going to let it slide.
  text = text.replace(/<br \/>/g, '<br>')
  // doing +1 to determine if last character is the end of a word or not
  const truncatedTextPlus1 = text.substring(0, truncateLength + 1)
  const lastSpaceIndex = truncatedTextPlus1.lastIndexOf(' ')
  let truncatedText
  if (lastSpaceIndex < 0) {
    // need to do a hard truncate because there is no space
    truncatedText = text.substring(0, truncateLength + truncateAllowance)
  } else if (lastSpaceIndex === truncatedTextPlus1.length - 1) {
    // last character is a space, just trim
    truncatedText = truncatedTextPlus1.trim()
  } else {
    truncatedText = text.substring(0, lastSpaceIndex).trim()
  }

  const lastOpenMarkupIndex = truncatedText.lastIndexOf(OPEN_CNTRL_CHAR)
  if (lastOpenMarkupIndex > -1) {
    if (truncatedText.substring(lastOpenMarkupIndex).indexOf(CLOSE_CNTRL_CHAR) === -1) {
      // add closing markup tag that will be hidden by truncation
      truncatedText = truncatedText + CLOSE_HIGHLIGHT_TAG
    }
    // put the highlight tags back in
    truncatedText = truncatedText.replace(new RegExp(OPEN_CNTRL_CHAR, 'g'), OPEN_HIGHLIGHT_TAG)
                              .replace(new RegExp(CLOSE_CNTRL_CHAR, 'g'), CLOSE_HIGHLIGHT_TAG)
  }
  return truncatedText
}

export function addHighlightClass(text) {
  if (!text) {
    return text
  }
  return text.replace(new RegExp(OPEN_HIGHLIGHT_TAG, 'g'), OPEN_HIGHLIGHT_TAG_WITH_CLASS)
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!(webpack)-strip-block!./src/util/text-utils.ts